module.exports = __webpack_public_path__ + "584cbcc3463805484ee0d6ec6da3fac4.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/franchises/aoe_background_0.jpg
// module id = 129
// module chunks = 0